import DonatePostViewerContainer from "../../containers/donate/DonatePost/DonatePostViewerContainer";

export default function DonatePostViewerPage () {
    
    return (
        <>
            <DonatePostViewerContainer />
        </>
    )
}